/**
 * Client-Side API Keys Configuration
 * 
 * These keys are meant to be exposed in the browser and are protected
 * through domain restrictions in their respective consoles, not through secrecy.
 * 
 * IMPORTANT: Only put CLIENT-SIDE keys here. Never put server-side secrets here.
 */

export const clientKeys = {
  /**
   * Google Maps API Key (browser / referrer-restricted only)
   * - Used for: Maps JavaScript API, Places (e.g. live storefront photos via `Place.fetchFields`)
   * - Restricted to: vaiu.app, *.vaiu.app, app.paywithvaiu.com, vaiupay.com, localhost (add origins in GCP as needed)
   * - Do not use server-only Places keys in the bundle; see docs/CONTEXT-merchant-media.md
   * - Console: https://console.cloud.google.com/apis/credentials
   */
  GOOGLE_MAPS_API_KEY: 'AIzaSyAr1Ga_IYeIgNCNxwtY-HJlkBb4-CEkzwA',
  
  /**
   * Google OAuth Client ID
   * - Used for: Google Sign-In
   * - Restricted to: Authorized JavaScript origins in Google Cloud Console
   * - This is a public client ID (security enforced via domain restrictions)
   */
  GOOGLE_CLIENT_ID: '377154411350-kvo2dhf9mp2muh7ds0lbm5vn8lldaqh6.apps.googleusercontent.com',
} as const;

// Type-safe access
export type ClientKeys = typeof clientKeys;
